var _g, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDuoSave(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    transform: "rotate(0 0 0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.25 3.25H5.5C4.25736 3.25 3.25 4.25736 3.25 5.5V18.5C3.25 19.7426 4.25736 20.75 5.5 20.75L7.25001 20.75L7.25 16.25C7.25 15.0074 8.25736 14 9.5 14L14.5 14C15.7426 14 16.75 15.0074 16.75 16.25V20.75H18.4999C19.7425 20.75 20.7499 19.7426 20.7499 18.5L20.7499 8.61418C20.7499 8.01685 20.5124 7.44403 20.0897 7.02197L16.9707 3.90779C16.5488 3.48658 15.977 3.25 15.3809 3.25H13.75L13.75 4.75C13.75 5.99264 12.7426 7 11.5 7H8.5C7.25736 7 6.25 5.99264 6.25 4.75V3.25Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.25 3.25H7.75V4.75C7.75 5.16421 8.08579 5.5 8.5 5.5H11.5C11.9142 5.5 12.25 5.16421 12.25 4.75L12.25 3.25Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.25 20.75V16.25C15.25 15.8358 14.9142 15.5 14.5 15.5L9.5 15.5C9.08579 15.5 8.75 15.8358 8.75 16.25L8.75001 20.75L15.25 20.75Z",
    fill: "currentColor"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 4.75L13.75 3.25H12.25L12.25 4.75C12.25 5.16421 11.9142 5.5 11.5 5.5H8.5C8.08579 5.5 7.75 5.16421 7.75 4.75V3.25H6.25V4.75C6.25 5.99264 7.25736 7 8.5 7H11.5C12.7426 7 13.75 5.99264 13.75 4.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 16.25L7.25001 20.75L8.75001 20.75L8.75 16.25C8.75 15.8358 9.08579 15.5 9.5 15.5L14.5 15.5C14.9142 15.5 15.25 15.8358 15.25 16.25V20.75H16.75V16.25C16.75 15.0074 15.7426 14 14.5 14L9.5 14C8.25736 14 7.25 15.0074 7.25 16.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuoSave);
export default __webpack_public_path__ + "static/media/DuoSave.33c4dd4509ad04b82850df32a73e72d1.svg";
export { ForwardRef as ReactComponent };